export default "__VITE_ASSET__D25AiiWX__"